import { ISelectOption } from '~/src/dash/components/dropdowns/common';

export enum EStatus {
  ShowAll = 0,
  Inactive,
  Active,
}

export const StatusOptions: ISelectOption[] = [
  { id: EStatus.ShowAll, label: 'Show All', tKey: 'ShowAll' },
  { id: EStatus.Active, label: 'Active', tKey: 'Active' },
  { id: EStatus.Inactive, label: 'Inactive', tKey: 'Inactive' },
];
